var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    directives: [{
      name: "ym-disable-keys",
      rawName: "v-ym-disable-keys"
    }],
    staticClass: "autocomplete-search-wrapper"
  }, [_c('SSelect', {
    attrs: {
      "theme": "secondary",
      "label": _vm.label,
      "size": "small",
      "z-index": 10,
      "is-autocomplete": "",
      "raw-autocomplete-text": _vm.internalValue
    },
    on: {
      "update:rawAutocompleteText": function updateRawAutocompleteText($event) {
        _vm.internalValue = $event;
      }
    }
  }, _vm._l(_vm.itemsMapped, function (item) {
    return _c('SOption', {
      key: item.id,
      class: _vm.YM_HIDE_CONTENT,
      attrs: {
        "value": item.id,
        "label": item.value
      }
    }, [_vm._v("\n      " + _vm._s(item.value) + "\n    ")]);
  }), 1)], 1);
};
var staticRenderFns = [];
export { render, staticRenderFns };